"use strict";

var React = require('react');
var ReactForms = require('react-forms');
var DateNode = ReactForms.schema.DateNode;
var createNode = ReactForms.schema.createNode;
var DateSelect = require('ofs/forms/inputs/date-select');

var Field = require('ofs/forms/components/better-field');

function DateScalar(props) {
  props.input = props.input || <DateSelect placeholder={props.placeholder} />;
  props.type = 'date';
  props.component = Field;
  return createNode(DateNode, props);
}

module.exports = DateScalar;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/scalars/DateScalar.jsx
 **/